<template>
    <div>
        <v-row no-gutters>
            <v-col cols=6>
                <div>
                    <v-icon small color="primary" class="mr-1">mdi-calendar-clock</v-icon>{{Date.formatFullShortRelative(start).capitalize()}}
                </div>
            </v-col>
            <v-col cols=6>
                <div>
                    <v-icon small color="primary" class="mr-1">mdi-clock-outline</v-icon>{{Date.newFull(start).hhmm()}}
                </div>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols=6>
                <div>
                    <v-icon small color="primary" class="mr-1">mdi-clock-outline</v-icon>{{service.duration}} {{$translate('minutes')}}
                </div>
            </v-col>
            <v-col cols=6>
                <div>
                    <v-icon small color="primary" class="mr-1">mdi-account-outline</v-icon>{{staffName}}
                </div>
            </v-col>
        </v-row>
        <template v-if="optionalResources && optionalResources.length">
            <div v-for="resource in resolvedOptionalResources" :key="resource.id" class="my-1">
                <v-avatar class="mr-2" :size="32">
                    <v-auto-img :src="resource.imagekey" />
                </v-avatar>
                {{resource.lastname}}
            </div>
        </template>
    </div>
</template>

<script>
import {getName} from '../util.js'
export default {
    name: 'zoezi-resourcebooking-checkout-item',

    props: ['service', 'start', 'staff', 'optionalResources'],

    computed: {
        staffName() {
            return getName(this.staff);
        },
        resolvedOptionalResources() {
            return this.optionalResources?.map(x => this.service.resources.find(r => r.id == x));
        }
    }
}
</script>
